<template>
    <div>

        <menu-bar></menu-bar>

        <div class="container" role="main">

            <div class="row" style="margin-top: 50px" v-if="cliente">

                <ol class="breadcrumb">
                    <li><a href="#/"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a href="#/pops">POPS</a></li>
                    <li class="active">CADASTRO DE POP</li>
                </ol>

                <div class="row">
                    <div class="col-md-3">
                        <menu-pop/>
                    </div>
                    <div class="col-md-9" >

                        <status-ping v-if="cliente.ip && cliente._id" :ip="cliente.ip"></status-ping>

                        <form class="form-horizontal">

                            <div class="panel panel-info">
                                <!-- Default panel contents -->
                                <div class="panel-heading">
                                    <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                                </div>
                                <div class="panel-body">
                                    <div class="form-group">

                                        <div class="col-sm-7">
                                            <label :class="{'text-danger': !cliente.nome}" class="control-label">NOME DO POP</label>
                                            <input :disabled="user.level >= 5" type="text" v-model="cliente.nome" class="form-control" >
                                        </div>

                                        <div class="col-sm-5">
                                            <label class="control-label">IP</label>
                                            <input :disabled="user.level >= 5" type="text" v-model="cliente.ip" class="form-control" >
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-info">
                                <div class="panel-heading">
                                    <i class="fa fa-info-circle" aria-hidden="true"></i> LISTAGEM DE IPs
                                </div>
                                <div class="panel-body">
                                    <div class="form-group">
                                        <div class="col-sm-5">
                                            <label class="control-label">NOME</label>
                                            <input :disabled="user.level >= 5" type="text" v-model="nome" class="form-control" >
                                        </div>
                                        <div class="col-sm-4">
                                            <label class="control-label">IP</label>
                                            <input :disabled="user.level >= 5" type="text" v-model="ip" class="form-control" >
                                        </div>
                                        <div class="col-sm-3">
                                            <label class="control-label">&nbsp;</label><br/>
                                            <a @click="add" class="btn btn-block btn-success" style="cursor: pointer">
                                                ADICIONAR
                                            </a>
                                        </div>

                                        <div class="col-sm-12">
                                            <br/><br/>
                                        </div>

                                        <div class="col-sm-12">
                                            <table id="mytable" class="table table-bordred table-striped">

                                                <thead>
                                                <tr>
                                                    <th >NOME</th>
                                                    <th style="text-align: center;width: 140px">IPS</th>
                                                    <th style="text-align: center;width: 100px">AÇÕES</th>
                                                </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="r in cliente.ips" v-bind:key="r._id">
                                                        <td>{{ r.nome }}</td>
                                                        <td style="text-align: center">{{ r.ip }}</td>
                                                        <td style="text-align: center">
                                                            <a @click="remove(r)" class="btn btn-danger btn-xs" style="cursor: pointer">
                                                                remover <i class="fa fa-remove" aria-hidden="true"></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>

                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-sm-10">
                                    <button type="button" v-if="user.level < 5" :disable="! cliente.nome"
                                            @click="save()"
                                            class="btn btn-success">
                                        <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR POP
                                    </button>
                                </div>
                            </div>

                        </form>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import MenuPop from "../../../menus/pops.vue";
import { router } from "../../../router";
import { Pops } from "../../../class/index";

import { Ssh, StatusPing } from "../../../components/exports";

export default {
    components: {
        MenuPop,
        Ssh,
        StatusPing
    },
    data() {
        return {
            ip: null,
            nome: null,
            cliente: null,
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.params.id) {
            this.load(this.$route.params.id);
        } else {
            this.cliente = Pops.create();
        }
    },
    methods: {
        add() {
            this.cliente.ips.push({
                ip: this.ip,
                nome: this.nome
            });
            this.ip = null;
            this.nome = null;
        },
        remove(ip) {
            for (let p in this.cliente.ips) {
                if (this.cliente.ips[p] === ip) {
                    this.cliente.ips.splice(p, 1);
                }
            }
        },
        load(id) {
            Pops.byID(id)
                .then(row => (this.cliente = row))
                .catch(err => {
                    console.log(err);
                });
        },
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o pop?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Pops.save(this.cliente)
                                .then(() => {
                                    resolve();
                                    router.push({ path: "/pops" });
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
